import styled from 'styled-components/macro';
import { rgba } from 'polished';

const ButtonRequestShow = styled.button`
  background-color: transparent;
  color: ${rgba('#fff', 0.6)};
  border: none;
  cursor: pointer;
`;

export default ButtonRequestShow;
